import { useEffect, useCallback } from "react";
import "./App.css";
import { Provider } from 'react-redux';
import { BrowserRouter, Routes, Route, useNavigate, useLocation } from "react-router-dom";
import "@fontsource/lato";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import "./assets/css/app.css";
import "./styles/globals.css";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import store from './store';
import { AuthProvider } from './context/AuthContext';
import { CommonProvider } from './context/CommonContext';
import { LanguageProvider } from "./utils/languageContext";
import AppLayout from "./Layout/AppLayout";
import LayoutWrapper from "./Layout/LayoutWrapper";
import AppRoutes from './routes';

// Component imports
import { Home } from "./modules/aggregator/pages/Home";
import { Login } from "./modules/aggregator/pages/Login";
import { FullPage404 } from "./modules/aggregator/pages/FullPage404";
import { Setting } from "./modules/aggregator/pages/Setting";
import { MyProfile } from "./modules/aggregator/pages/MyProfile";
import BenificeryEnterby from "./modules/aggregator/pages/BenificeryEnterby";
import UIPVaccinationCenter from "./modules/uwin/admin/UIPVaccinationCenter";
import CreateVaccinationSession from './modules/uwin/admin/CreateVaccinationSession';
import DueList from "./modules/uwin/components/DueList";
import Newhomepage from "./modules/aggregator/pages/Newhomepage";
import Screenreaderpage from "./modules/aggregator/pages/Screenreaderpage";
import Sitemappage from "./modules/aggregator/pages/Sitemappage";
import Morefaqpage from "./modules/aggregator/pages/Morefaqpage";
import Usearmanualpage from "./modules/aggregator/pages/Usearmanualpage";
import PrivacyPolicypage from "./modules/aggregator/pages/PrivacyPolicypage";
// import NewRegistration from "./modules/FBNC/Component/NewRegistration";
import ClientRegistration from "./modules/AFHC/ClientRegistration";
// import RegistrationWizard from "./modules/Eopd/Components/RegistrationWizard";
// import Faclitydetails from "./modules/RCH/Faclitydetails";
// import Pncmother from "./modules/RCH/Pncmother";
// import Dethmodule from "./modules/RCH/Dethmodule";
import ChildDetails from "./modules/RCH/Chileddetails";
import AmbaRegistration from "./modules/AMBA/Ambaregistraion";
const userRole = "null";

function App() {

  useEffect(() => {
    const saved = localStorage.getItem("fontSize");
    if (saved) {
      document.documentElement.style.setProperty("--font-size", saved + "px");
    }
  }, []);

  return (
    <Provider store={store}>
      <AuthProvider>
        <CommonProvider>
          <LanguageProvider>
            <BrowserRouter>
              <Routes>
                <Route path="/" element={<Newhomepage />} />
                {/* <Route path="/" element={<Home />} /> */}
                {/* <Route path="/" element={<Login />} /> */}
                <Route path="/login" element={<Login />} />
                <Route path="/newhomepage" element={<Newhomepage />} />
                <Route path="/screen-reader" element={<Screenreaderpage />} />
                <Route path="/sitemap" element={<Sitemappage />} />
                <Route path="/user-manual" element={<Usearmanualpage />} />
                <Route path="/more-faq" element={<Morefaqpage />} />
                <Route path="/Privacy-policy" element={<PrivacyPolicypage />} />
                {/* <Route path="/FBNC-Registration" element={<NewRegistration />} />
                <Route path="/Eopd-registration" element={<RegistrationWizard />} /> */}
                 <Route path="/Faclity-details" element={<AmbaRegistration />} /> 

                <Route
                  element={
                    <LayoutWrapper>
                      <AppLayout userRole={userRole} />
                    </LayoutWrapper>
                  }
                >

                  <Route path="/*" element={
                    <SessionTimeoutHandler>
                      <AppRoutes />
                    </SessionTimeoutHandler>
                  } />

                  {/* <Route element={<AppLayout userRole={userRole} />}>
                  <Route path="/*" element={
                    <SessionTimeoutHandler>
                      <AppRoutes />
                    </SessionTimeoutHandler>
                  } /> */}

                  <Route path="/setting" element={
                    <SessionTimeoutHandler>
                      <Setting />
                    </SessionTimeoutHandler>
                  } />
                  <Route path="/uip-vaccination-center" element={
                    <SessionTimeoutHandler>
                      <UIPVaccinationCenter />
                    </SessionTimeoutHandler>
                  } />
                  <Route path="/create-vaccination-session" element={
                    <SessionTimeoutHandler>
                      <CreateVaccinationSession />
                    </SessionTimeoutHandler>
                  } />
                  <Route path="/myprofile" element={
                    <SessionTimeoutHandler>
                      <MyProfile />
                    </SessionTimeoutHandler>
                  } />
                  <Route path="/BenificeryEnterby" element={
                    <SessionTimeoutHandler>
                      <BenificeryEnterby />
                    </SessionTimeoutHandler>
                  } />
                  <Route path="/DueList" element={
                    <SessionTimeoutHandler>
                      <DueList />
                    </SessionTimeoutHandler>
                  } />
                  <Route path="/afhc/client-registration" element={
                    <SessionTimeoutHandler>
                      <ClientRegistration />
                    </SessionTimeoutHandler>
                  } />

                </Route>

              </Routes>
              <ToastContainer
                position="top-right"
                autoClose={3000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
                closeButton={true}
              />
            </BrowserRouter>
          </LanguageProvider>
        </CommonProvider>
      </AuthProvider>
    </Provider >
  );
}

function SessionTimeoutHandler({ children }) {
  const navigate = useNavigate();

  const handleSessionTimeout = useCallback(() => {
    localStorage.clear();
    navigate("/");
  }, [navigate]);

  useEffect(() => {
    const sessionTimeout = 480 * 60 * 1000; // 30 minutes in milliseconds

    const timer = setTimeout(() => {
      handleSessionTimeout();
    }, sessionTimeout);

    return () => clearTimeout(timer);
  }, [handleSessionTimeout]);

  return children;
}

export default App;
